import React from 'react';
import { FemaGoTable } from 'app-ui-componentlibrary';
import _ from 'lodash';
import { Icon } from 'semantic-ui-react';

const Table = ({ userData, fetchUserToManage, fetchSignatureTitleInfo, toggleManageModal }) => {
    return (
        <>
            <p />
            <FemaGoTable type="static" summary="Manage your team">
                <FemaGoTable.Header>
                    <FemaGoTable.Row>
                        <FemaGoTable.HeaderCell>Name</FemaGoTable.HeaderCell>
                        <FemaGoTable.HeaderCell>Email</FemaGoTable.HeaderCell>
                        <FemaGoTable.HeaderCell>Actions</FemaGoTable.HeaderCell>
                    </FemaGoTable.Row>
                </FemaGoTable.Header>
                <FemaGoTable.Body divided="true">
                    {
                        _.map(userData, (user, index) => {
                            return (
                                <FemaGoTable.Row>
                                    <FemaGoTable.TextCell>
                                        <b>{user.firstName} {user.lastName}</b>
                                        <a className="padding-left" target="_blank" title={`Chat with ${user.firstName} ${user.lastName}`} href={`https://teams.microsoft.com/l/chat/0/0?users=${user.emailAdr}`}>
                                            <Icon name="chat" />
                                        </a>
                                    </FemaGoTable.TextCell>
                                    <FemaGoTable.TextCell>
                                        {user.emailAdr}
                                    </FemaGoTable.TextCell>
                                    <FemaGoTable.TextCell>
                                        <a
                                            href="#"
                                            name={`manage-${index}`}
                                            title={`Manage ${user.emailAdr}`}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                fetchUserToManage(user.emailAdr);
                                                fetchSignatureTitleInfo(user.emailAdr);
                                                toggleManageModal();
                                            }}
                                        >
                                            <Icon name="user" />
                                            Manage
                                        </a>
                                    </FemaGoTable.TextCell>
                                </FemaGoTable.Row>
                            )
                        })
                    }
                </FemaGoTable.Body>
            </FemaGoTable>
        </>
    )
}

export default Table;